import React from "react";
import { ErrorCard } from "../errorCard";
import { NoAccessCard } from "../NoAccessCard";
import SkypointLogoLoader from "../SkypointLogoLander/SkypointLogoLoader";
import SetupPage from "../accountSetupPage/setupPage";

interface AppLoadingStatesProps {
  userAccesstoInstance: boolean;
  showExternalTenantCreationError: boolean;
  isCheckResourceFailed: boolean;
  isShowCreateTenant: boolean;
  createOwnInfrastructure: boolean;
  isSetupFinished: boolean;
  hideExternalTenantCreationError: () => void;
  createResourceForTenant: () => void;
  createOwnInfrastructureFn: () => void;
}

export function AppLoadingStates({
  userAccesstoInstance,
  showExternalTenantCreationError,
  isCheckResourceFailed,
  isSetupFinished,
  hideExternalTenantCreationError,
}: AppLoadingStatesProps) {
  if (!userAccesstoInstance) {
    return <NoAccessCard />;
  }

  if (showExternalTenantCreationError) {
    return (
      <ErrorCard
        errorDescription={
          <>
            An error occurred while setting up the infrastructure. Please try again. If the problem
            persists,{" "}
            <a
              href="https://skypoint.ai/support"
              target="_blank"
              style={{ fontWeight: "600" }}
              rel="noreferrer"
            >
              Contact support
            </a>
          </>
        }
        showRefreshButton={true}
        refreshButtonText="Try again"
        callBackFunctionOnRefresh={hideExternalTenantCreationError}
      />
    );
  }

  if (isCheckResourceFailed) {
    return <SkypointLogoLoader />;
  }

  return <SetupPage isSetupFinished={isSetupFinished} />;
}

export default AppLoadingStates;
